import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { formatDate, sortDateDescending } from "@/core/utils/date";

interface WithSpiffDates {
  trigger?: { created_at: string };
  created_at: string;
}

const SpiffDateCol = <T extends WithSpiffDates>(): ColumnDef<T> => ({
  header: "Spiff date",
  accessorFn: (row) => row.trigger?.created_at || row.created_at,
  enableSorting: true,
  sortingFn: (rowA, rowB) => {
    const aDate = rowA.original.trigger?.created_at || rowA.original.created_at;
    const bDate = rowB.original.trigger?.created_at || rowB.original.created_at;
    return sortDateDescending(aDate, bDate);
  },
  sortDescFirst: true,
  cell: ({ row }) => {
    const date = row.original.trigger?.created_at || row.original.created_at;
    return (
      <Stack gap="xs">
        <Typography variant="bodyW1">{formatDate(date)}</Typography>
        <Typography variant="captionW1" textColor="tertiary">
          {dayjs(date).format("h:mm A")}
        </Typography>
      </Stack>
    );
  },
});

export default SpiffDateCol;
